export const DOCUMENTS_FETCH = "DOCUMENTS_FETCH";
export const DOCUMENTS_FETCH_SUCCESS = "DOCUMENTS_FETCH_SUCCESS";
export const DOCUMENTS_RESET = "DOCUMENTS_RESET";
